'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getContentHeight;

var _isMobile = require('./isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizes = {
	banner: { mobile: 60, tablet: 40, desktop: 40 },
	appBar: { mobile: 60, tablet: 80, desktop: 80 },
	footer: { mobile: 80, tablet: 60, desktop: 60 }
};

function getContentHeight() {
	var bannerExist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	var deviceType = _isMobile2.default ? 'mobile' : 'desktop';

	var bannerSize = bannerExist ? sizes.banner.desktop : 0;
	var appBarSize = sizes.appBar[deviceType];
	var footerSize = sizes.footer[deviceType];

	var reservedTop = bannerSize + appBarSize - 1;
	return reservedTop + footerSize;
}